module.exports = __webpack_public_path__ + "img/44_17.9f81df58.png";